import { Draft } from 'immer';
import { predictionInsightRules } from './predictionInsightRules';

export function evaluateClientInsights(client: Client | Draft<Client>): ClientInsight[] {
  const insights: ClientInsight[] = [];

  for (const rule of predictionInsightRules) {
    const result = rule(client as Client);
    if (result) {
      insights.push(result);
    }
  }

  return insights;
}
